(function () {
	// init formcrafts form and set values from data attribute
	function initFormcrafts() {
		document.querySelectorAll("[data-formcrafts]").forEach((el) => {
			if (el.dataset.fcLoaded === "1") return;
			if (!window.formcrafts || !formcrafts.createInlineForm) return;

			el.dataset.fcLoaded = "1";

			formcrafts.createInlineForm({
				form: el.dataset.formId,
				lang: el.dataset.lang,
				target: el,
				seamless: true,
				redirectWithin: true,
				values: JSON.parse(el.dataset.values || "{}")
			});
		});
	}

	function applyBuyNowBtnState(sectionId, variant) {
		if (!sectionId || !variant) return;

    // Update FormCrafts hidden values
		const fc = document.querySelector(`#product-waitlist-${sectionId} [data-formcrafts]`);
		if (fc) {
			let values = {};
			try {
				values = JSON.parse(fc.dataset.values || "{}");
			} catch (e) {}

			values.field10 = String(variant.id);
			values.field11 = String(variant.sku || "");

			fc.dataset.values = JSON.stringify(values);

			fc.dataset.fcLoaded = "0";
		}

    // Toggle buttons + update Klaviyo variant id
		const wrap = document.querySelector(`[data-bis-buttons][data-section-id="${sectionId}"]`);
    if (!wrap) return;

		const meta = wrap.querySelector("[data-bis-meta]");
		const isNewSKU = meta?.dataset.isNewsku === "true";

		const waitlistWrap = wrap.querySelector("[data-waitlist-wrap]");
		const bisBtn = wrap.querySelector("[data-bis-wrap]");
		const buyNowBtn =
			wrap.querySelector("[data-buy-now-btn]") ||
			document.getElementById(`ProductSubmitButton-${sectionId}`);

    // Always keep Klaviyo variant id in sync (even if hidden)
		if (bisBtn) {
			bisBtn.setAttribute("data-variant-id", String(variant.id));
			bisBtn.dataset.variantId = String(variant.id);
		}

		const isAvailable = !!variant.available;

		if (isAvailable) {
			// In stock: show buy now, hide both BIS options
			if (buyNowBtn) {
        
				buyNowBtn.hidden = false;
				buyNowBtn.disabled = false;
			}
			if (waitlistWrap) waitlistWrap.hidden = true;
			if (bisBtn) bisBtn.hidden = true;
		} else {
			// Out of stock: hide buy now, show correct BIS option
			if (buyNowBtn) {
				buyNowBtn.hidden = true;
				buyNowBtn.disabled = true;
			}

			if (isNewSKU) {
				if (waitlistWrap) waitlistWrap.hidden = false;
				if (bisBtn) bisBtn.hidden = true;
			} else {
				if (waitlistWrap) waitlistWrap.hidden = true;
				if (bisBtn) bisBtn.hidden = false;
			}
		}

		initFormcrafts();
	}

  function initBuyNowBtnStateOnLoad() {
    // find each product-form (each has data-section-id)
    document.querySelectorAll("product-form[data-section-id]").forEach((pf) => {
      const sectionId = pf.dataset.sectionId;
      
      // get selected variant id from the hidden input
      const idInput = pf.querySelector('input[name="id"]');
      const variantId = idInput?.value;
      if (!variantId) return;

      const productInfo = pf.closest('product-info');
      const selectedVariantJson = productInfo?.querySelector('[data-selected-variant]');
      if (!selectedVariantJson) return;

      let variant;
      try {
        variant = JSON.parse(selectedVariantJson.textContent);
      } catch (e) {
        return;
      }

      if (!variant || String(variant.id) !== String(variantId)) return;

      applyBuyNowBtnState(sectionId, variant);
    });
  }
  
	document.addEventListener("DOMContentLoaded", initFormcrafts);
	document.addEventListener("product-info:loaded", initFormcrafts);

  document.addEventListener("DOMContentLoaded", initBuyNowBtnStateOnLoad);
  document.addEventListener("product-info:loaded", initBuyNowBtnStateOnLoad);
	
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
		const { sectionId, variant } = data;
    applyBuyNowBtnState(sectionId, variant);
	});

	document.addEventListener("click", (e) => {
		// CLOSE dialog
		const closeBtn = e.target.closest("[data-close-dialog]");
		if (closeBtn) {
			const dialog = closeBtn.closest("dialog");
			if (dialog && dialog.open) {
				dialog.close();
			}
			return;
		}

		// OPEN dialog
		const openBtn = e.target.closest("[data-open-dialog]");
		if (openBtn) {
			const dialog = document.getElementById(openBtn.dataset.openDialog);
			if (dialog && !dialog.open) {
				dialog.showModal();
			}
		}
	});

  // add gtag on BIS form submit
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".klaviyo-bis-trigger");
    if (!trigger) return;

    // Wait for iframe to exist & load
    setTimeout(() => {
      const iframe = document.querySelector("#klaviyo-bis-modal");
      const btn = iframe?.contentWindow?.document?.querySelector(".btn");
      if (!btn) return;

      // Bind once
      if (btn.dataset.gtagBound === "1") return;
      btn.dataset.gtagBound = "1";

      btn.addEventListener("click", () => {
        gtag("event", "submit_form", {
          event_category: "Form Submissions",
          event_label: "Out Of Stock Form",
          value: 1,
        });
      });
    }, 250);
  });
})();
